import { manageInvitesReducer } from "./manageInvitesSlice";
import { combineReducers } from "redux";
import { dashboardReducer } from "./dashboardSlice";
import { propertieReducer } from "./propertieSlice";
import { agencyReducer } from "./agencySlice";
import { agentReducer } from "./agentSlice";
import { userReducer } from "./userSlice";
import { templateReducer } from "./templateSlice";
import { designTemplateReducer } from "./designTemplateSlice";
import { subscriptionReducer } from "./subscriptionSlice";
import { commonReducer } from "./commonSlice";

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  propertie: propertieReducer,
  manageInvites: manageInvitesReducer,
  agency: agencyReducer,
  agent: agentReducer,
  user: userReducer,
  template: templateReducer,
  designTemplate: designTemplateReducer,
  subscription: subscriptionReducer,
  common: commonReducer,
});

export default rootReducer;
